import type { EthersError } from 'ethers';
import { BaseError } from 'viem';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

const isEthersError = (error: Error): error is EthersError =>
  Object.hasOwn(error, 'code') && Object.hasOwn(error, 'shortMessage');

export const getEthersCode = (error: Error): string | null =>
  isEthersError(error) ? error.code : null;

export const tryGetEthersError = (error: Error, action = 'Contract interaction'): string => {
  switch (getEthersCode(error)) {
    case 'ACTION_REJECTED':
      return `${action} rejected by user`;
    default:
      return error.message;
  }
};

export const getViemError = (error: Error) => {
  if (error instanceof BaseError) {
    return error.shortMessage;
  }

  return error.message;
};

export const tryTo = <T extends unknown[], U>(fn: (...args: T) => U, ...args: T): U | undefined => {
  try {
    return fn(...args);
  } catch {
    return undefined;
  }
};
